import {Pipe, PipeTransform} from '@angular/core';
import {Window} from '../models/vision/movie';

export function windowLabel(window: Window | string | null | undefined): string {
  switch (window) {
    case Window.Pay1:
      return 'Pay 1 / SVOD 1';
    case Window.Pay2:
      return 'SVOD 2';
    case Window.Pay3:
      return 'SVOD 3';
    default:
      return window || '';
  }
}

@Pipe({name: 'appWindowLabel'})
export class WindowLabelPipe implements PipeTransform {
  transform(window: Window | string | null | undefined): string {
    return windowLabel(window);
  }
}
